import { Link, NavLink, Outlet } from "react-router-dom";
import { Home, Camera, Images, Shield } from "lucide-react";
import { Toaster } from "sonner";

const tabs = [
  { to: "/", label: "Home", icon: Home, end: true, testId: "tab-home" },
  { to: "/sign?camera=1", label: "Snap", icon: Camera, testId: "tab-sign" },
  { to: "/gallery", label: "Gallery", icon: Images, testId: "tab-gallery" },
  { to: "/admin", label: "Host", icon: Shield, testId: "tab-admin" },
];

function TabItem({ to, end, label, icon: Icon, testId }) {
  return (
    <NavLink
      to={to}
      end={end}
      data-testid={testId}
      className={({ isActive }) =>
        `flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 rounded-2xl transition-colors ${
          isActive
            ? "text-[#111]"
            : "text-[#8a8a8a] hover:text-[#111]"
        }`
      }
    >
      {({ isActive }) => (
        <>
          <Icon size={22} strokeWidth={isActive ? 2.25 : 1.75} />
          <span className={`text-[10px] font-medium tracking-tight ${isActive ? "" : "opacity-80"}`}>
            {label}
          </span>
        </>
      )}
    </NavLink>
  );
}

export default function Layout() {
  return (
    <div className="phone-shell">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-white/85 border-b border-black/5">
        <div className="px-5 pt-3 pb-3 flex items-center justify-center">
          <Link to="/" data-testid="brand-link" className="flex items-center gap-2">
            <img
              src="/brand/hostbydims-mark.png"
              alt="hostbydims"
              className="h-12 w-auto object-contain"
              data-testid="brand-logo"
            />
            <span className="hidden xs:inline-block text-[10px] font-medium uppercase tracking-[0.18em] text-[#8a8a8a] border-l border-[#e5e5e5] pl-2">
              Guest Gallery
            </span>
          </Link>
        </div>
      </header>

      <main className="pb-6">
        <Outlet />
      </main>

      <nav className="tab-bar" aria-label="Primary">
        <div className="flex items-stretch gap-1 max-w-[380px] mx-auto">
          {tabs.map((t) => (
            <TabItem key={t.to} {...t} />
          ))}
        </div>
      </nav>

      <Toaster position="top-center" richColors />
    </div>
  );
}
